module.exports = __webpack_public_path__ + "static/media/minimize_icon.0ddeb590.svg";